import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';

// Popup de autocompletar @mención, montado por `props.mount()` de @tiptap/suggestion (ver
// taskCommentSuggestion.js) -- reemplaza el dropdown manual que vivía en
// ComponentTaskHoy.jsx:5862-5890 (createPortal + mentionDropdownCoords calculados a mano).
export const MentionList = forwardRef(({ items, command }, ref) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => setSelectedIndex(0), [items]);

    const selectItem = useCallback((index) => {
        const item = items[index];
        if (item) command(item);
    }, [items, command]);

    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                setSelectedIndex((prev) => (prev + items.length - 1) % items.length);
                return true;
            }
            if (event.key === 'ArrowDown') {
                setSelectedIndex((prev) => (prev + 1) % items.length);
                return true;
            }
            if (event.key === 'Enter' || event.key === 'Tab') {
                selectItem(selectedIndex);
                return true;
            }
            if (event.key === 'Escape') return true;
            return false;
        },
    }), [items, selectedIndex, selectItem]);

    if (!items || items.length === 0) return null;

    return (
        <div className="mention-suggestions" role="listbox">
            {items.map((item, i) => (
                <div
                    key={item.id}
                    className={`mention-item ${i === selectedIndex ? 'selected' : ''}`}
                    role="option"
                    aria-selected={i === selectedIndex}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        selectItem(i);
                    }}
                >
                    <img src={item.avatar} className="mention-avatar" alt="" loading="lazy" />
                    <span className="mention-name">{item.nick}</span>
                </div>
            ))}
        </div>
    );
});
MentionList.displayName = 'MentionList';
